<template>

  <div id="main">
    <ScreenAdapter>
      <Header />
      <Nav />
      <div class="platform-cover" :style="`background: url('${cover?cover:''}') no-repeat center/cover`">
        <div class="player-box" @click="jumpDetail()" :style="`background:url(${(courseInfo&&courseInfo.photo)?courseInfo.photo:''}) no-repeat center/cover;`">
          <div v-if="courseInfo&&courseInfo.photo" class="mask"></div>
        </div>
      </div>
      <div class="eol-main-container">
        <div class="tabs-card">
          <div @click="toPosition('#detail',1)" class="tabs-item active">课程详情</div>
          <div @click="toPosition('#content',2)" class="tabs-item">课程内容</div>
          <div @click="toPosition('#appraise',3)" class="tabs-item">课程评价</div>
        </div>
        <div class="tabs-content">
          <!-- 课程详情 -->
          <div class="details-content" id="detail">
            <div class="details-color" ref="color">
              <div class="content-header" ref="ref-1">课程详情</div>
              <div class="content-box" v-html="intro" v-if="courseInfo&&courseInfo.id"></div>
            </div>

          </div>
          <!-- 课程内容 -->
          <div class="details-list">
            <div id="content"></div>
            <div class="content-header" ref="ref-2">课程内容</div>
            <div class="content-box">
              <div class="course-item" @click="jumpDetail(item.id)" v-for="item,index in chapterInfo" :key="index" :style="`background:url(${item.photo}) no-repeat center/cover;`">
                <p>{{ item.name }}</p>
              </div>
              <div class="sub-visibility"></div>
            </div>
          </div>
          <!-- 课程评价 -->
          <div class="details-appraise">
            <div id="appraise"></div>
            <div class="appraise-content" ref="ref-3">
              <div class="appraise-header">课程评价</div>
              <div class="content-box">
                <template v-if="appraiseList&&appraiseList.length>0">
                  <div class="appraise-item" v-for="item, index in appraiseList" :key="index">
                    <template>
                      <div class="avatar"></div>
                      <div class="appraise-info">
                        <div class="basic-info">
                          <div class="user-info">
                            <div class="user-name">{{ item.user_name }}</div>
                            <div class="star-content">
                              <div :class="['star-item',s_index+1>item.level?'empty':'']" v-for="s_item,s_index in 5" :key="s_index"></div>
                            </div>
                          </div>
                          <div class="publish-time">{{ item.created_at }}</div>
                        </div>
                        <div class="appraise-text" v-text="item.content"></div>
                      </div>
                    </template>
                  </div>
                </template>
                <div class="empty-content" v-else>
                  <p class="empty-text">暂无评价~</p>
                </div>

              </div>
            </div>
            <div class="suggest-content">
              <div class="appraise-header">课程推荐</div>
              <div class="content-box">
                <div class="course-item" @click="jumpDetail(item.id,'self')" v-for="item,index in randomCourse" :key="index" :style="`background:url(${item.photo}) no-repeat center/cover;`">
                </div>
              </div>
            </div>
          </div>
          <!-- 评价 -->
          <div class="appraise-container">
            <div class="appraise-header">
              <div class="appraise-star">
                <div class="header-text">请对课程进行评价</div>
                <div class="header-score">
                  <div :class="['score-item',index+1>appraiseScore?'unActive':'']" v-for="item,index in 5" :key="index" @click="handleScore(index)"></div>
                </div>
              </div>
              <div class="appraise-submit" @click="appraiseSubmit()">发表</div>
            </div>
            <div class="appraise-area">
              <textarea placeholder="在这里输入你的评价~" v-model="appraiseContent"></textarea>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </ScreenAdapter>
    <div :class="['fixed-nav',isFixed?'fixed':'']" :style="{top:!isFixed?style.top:'',left:style.left}">
      <div @click="toPosition('#detail',1)" :class="['fixed-nav-item',isFixedId == 1?'active' :'']">课程详情</div>
      <div @click="toPosition('#content',2)" :class="['fixed-nav-item',isFixedId == 2?'active' :'']">课程内容</div>
      <div @click="toPosition('#appraise',3)" :class="['fixed-nav-item',isFixedId == 3?'active' :'']">课程评价</div>
    </div>
  </div>

</template>

<script>
import Header from "@/components/Hzvtc/Header.vue"
import Nav from "@/components/Hzvtc/Nav.vue"
import Footer from "@/components/Hzvtc/Footer.vue"
import ScreenAdapter from "@/components/ScreenAdapter.vue"
import services from '../../config/services'
import { Message } from "ant-design-vue"
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
import { mapState } from "vuex"
export default {
  data () {
    return {
      zh_CN,
      school_code: localStorage.getItem("schoolCode"),
      cover: "", // 动态封面图
      appraiseList: [],//评价列表
      appraiseContent: "",// 评价内容
      appraiseScore: 5, // 评价分数
      windowHeight: document.documentElement.clientHeight, // 可视窗口高度
      isFixed: false, // 是否固定左侧菜单
      isFixedId: 1, // 当前固定的菜单id
      courseInfo: {}, // 课程详细
      chapterInfo: [], // 课程章节
      firstId: "",// 一级课程分类
      keyList: [
        { path: "culture", id: "106", course_ids: [107, 108, 109, 118] },
        { path: "value", id: "110", course_ids: [111, 112, 113] },
        { path: "feelings", id: "121", course_ids: [193, 194] },
        { path: "profession", id: "136", course_ids: [137, 139] },
        { path: "feature", id: "", course_ids: [201, 202] },
        { path: "vita", id: "152", course_ids: [153, 154, 155, 156] },
      ],
      randomCourse: [],//推荐的随机课程
      coverList: [
        { path: "culture", cover: require('../../assets/hzvtc/cover/culture.png') },
        { path: "value", cover: require('../../assets/hzvtc/cover/value.png') },
        { path: "feelings", cover: require('../../assets/hzvtc/cover/feelings.png') },
        { path: "profession", cover: require('../../assets/hzvtc/cover/profession.png') },
        { path: "feature", cover: require('../../assets/hzvtc/cover/feature.png') },
        { path: "vita", cover: require('../../assets/hzvtc/cover/vita.png') },
      ],
      key: "",
      style: {
        top: "",
        left: ""
      },
      studyBan: false, // 是否可以学习
      intro: "" // 课程介绍,
    }
  },
  components: {
    Header,
    Nav,
    Footer,
    ScreenAdapter
  },
  async mounted () {
    let that = this
    let key = that.$route.query.key || localStorage.getItem("eol-hzvtc-detail-key") || that.key

    that.cover = that.coverList.find(item => item.path == key).cover

    if (that.$route.query.reload) {
      window.open(`/center/${that.school_code}/hzvtc/detail?id=${that.$route.query.id || localStorage.getItem("hz-id")}&key=${key}`, "_self")
    }

    window.addEventListener("scroll", that.handleScroll, true)
    that.handleScroll(true)
    // window.onresize = function () {
    //   that.handleScroll()
    // }
    await that.getFirstId()
    await that.getCourseDetails()
    await that.getCourseChapterDetail()
    await that.getCourseComment(true)
  },
  methods: {
    // 改变评价星级
    handleScore (val) {
      this.appraiseScore = val + 1
    },
    // 跳转到课程详情
    jumpDetail (cmid, self) {
      if (this.studyBan) {
        return Message.error("您暂无权限学习")
      }
      let key = this.$route.query.key || localStorage.getItem("eol-hzvtc-detail-key")
      let palyId = cmid ? cmid : 0

      // 记录key 课程id,防止播放课程页点击返回参数丢失
      localStorage.setItem("eol-hzvtc-detail-key", key)
      localStorage.setItem("hz-id", this.$route.query.id)
      if (self) {
        return window.open(`/center/${this.school_code}/hzvtc/detail?id=${cmid}&key=${key}`, true)
      }
      if (!this.loginUserInfo) {
        // return window.open(`${services.LOGIN_SERVER}/${this.school_code}/login?from=${window.location.href}`, "_self")
        return window.open(`${services.APPS_SERVIER}/api/redirect?school_code=${this.school_code}&from=${window.location.href}`, "_self")
      }
      window.open(`/center/${this.school_code}/video/${this.courseInfo.id}/${palyId}?from=${this.$route.path}&id=${cmid}&key=${key}`, "_blank")
    },
    // 提交评价
    async appraiseSubmit () {
      if (this.appraiseContent.length < 5) {
        return Message.error("至少输入5个字")
      }
      await services.addCourseComment({ course_id: this.$route.query.id, level: this.appraiseScore, content: this.appraiseContent }).then(res => {
        if (res.code == '0000') {
          Message.success("评价成功");
          this.getCourseComment()
          this.appraiseContent = ""
        } else {
          Message.error(res.message);
        }
      })
    },
    handleScroll () {
      let that = this
      that.$nextTick(() => {
        let positionTop = that.$refs.color.getBoundingClientRect().top + 'px'
        let positionLeft = (that.$refs.color.getBoundingClientRect().left - 148 - 40) + 'px'

        that.style.top = positionTop
        that.style.left = positionLeft

        let element = document.getElementsByClassName("outContainer")[0]
        let scrollTop = element.scrollTop;
        that.isFixed = scrollTop + 40 >= that.windowHeight ? true : false
        if (that.$refs['ref-1'] && that.$refs['ref-2'] && that.$refs['ref-1']) {
          let div1 = that.$refs['ref-1'].getBoundingClientRect().top + 50
          let div2 = that.$refs['ref-2'].getBoundingClientRect().top + 50
          let div3 = that.$refs['ref-3'].getBoundingClientRect().top + 50
          if (div1 > 0) {
            that.isFixedId = 1
          } else if (div2 > 0) {
            that.isFixedId = 2
          } else if (div3 > 0) {
            that.isFixedId = 3
          }
        }
      })
    },
    // 锚点定位
    toPosition (node, id) {
      document.querySelector(node).scrollIntoView(true);
      this.isFixedId = id
    },
    // 获取课程详情
    getCourseDetails () {
      services.getCourseDetails({ id: this.$route.query.id }).then(res => {
        this.courseInfo = res.data
        var html = res.data.intro
        html = html.replace(/\s\s+/g, '');
        this.intro = html
      })
    },
    // 获取课程章节
    getCourseChapterDetail () {
      services.getCourseChapterDetail({ id: this.$route.query.id, data: { action: "learn" } }).then(res => {
        if (res.code == '2004') {
          // 未加入班级，禁止学习
          this.studyBan = true
        }
      })
      services.getCourseMaterial({ school_code: this.school_code, course_id: this.$route.query.id, page: 1, size: 100 }).then(res => {
        this.chapterInfo = res.data.items
      })
    },
    // 获取课程评价
    async getCourseComment (init) {
      await services.getCourseComment({ course_id: this.$route.query.id }).then(res => {
        this.appraiseList = res.data.items
      })
      if (init) {
        let that = this
        that.$nextTick(() => {
          let positionTop = that.$refs.color.getBoundingClientRect().top + 'px'
          let positionLeft = (that.$refs.color.getBoundingClientRect().left - 148 - 40) + 'px'
          that.style.top = positionTop
          that.style.left = positionLeft
        })
      }


    },
    // 取一级分类id下随机课程
    async getFirstId () {
      let that = this
      let key = that.$route.query.key || localStorage.getItem("eol-hzvtc-detail-key")
      let row = that.keyList.find(item => {
        that.key = item.key
        return item.path == key
      })
      let randomId = Math.floor(Math.random() * (row.course_ids.length));
      await services.getCourseList({ page: 1, size: 2, category_id: row.course_ids[randomId], school_code: this.school_code }).then(res => {
        that.randomCourse = res.data.items
      })

      // that.keyList.forEach(row => {
      //   if (row.course_ids) {
      //     row.course_ids.forEach(sub_row => {
      //       console.log(sub_row);
      //     })
      //   }
      // })
    },

  },
  computed: {
    ...mapState({
      loginUserInfo: (state) => state.appsLogin.appsUserInfo,
    })
  },
  destroyed () {
    window.removeEventListener("scroll", this.handleScroll)
  }
}
</script>

<style lang="less" scoped>
#main {
  background: #fff;
}
.platform-cover {
  width: 100%;
  height: 510px;
  position: relative;
  margin-bottom: 26px;
  border-bottom: 8px solid #b61e2a;
  .player-box {
    width: 508px;
    height: 281px;
    position: absolute;
    bottom: -26px;
    left: 50%;
    transform: translateX(-50%);
    border: 3px solid #ae261f;
    cursor: pointer;
    &::before {
      content: '';
      display: inline-block;
      background: url('../../assets/hzvtc/detail/main-cover.png') no-repeat
        center/cover;
      width: 565px;
      height: 26px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: -3px;
    }
    &::after {
      content: '';
      display: inline-block;
      background: url('../../assets/hzvtc/detail//player.png') no-repeat
        center/cover;
      width: 120px;
      height: 120px;
      position: absolute;
      left: 50%;
      top: 34%;
      transform: translateX(-50%);
      z-index: 10;
    }
    .mask {
      position: absolute;
      width: 100%;
      height: 100%;
      background: #8e8e8e;
      opacity: 0.38;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
.eol-main-container {
  width: 1200px;
  margin: 0 auto;
  padding: 60px 0 0;
  .tabs-card {
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 1;
    margin-bottom: 30px;
    .tabs-item {
      font-size: 22px;
      font-weight: bold;
      color: #333333;
      cursor: pointer;
      display: block;
      &:not(:last-child) {
        margin-right: 137px;
      }
      &.active {
        background: linear-gradient(180deg, #e9683f 0%, #b61e2a 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        &::before {
          content: '';
          display: inline-block;
          width: 16px;
          height: 16px;
          background: url('../../assets/hzvtc/detail/tabs-active.png') no-repeat
            center/cover;
          margin-right: 13px;
        }
      }
    }
  }
  .tabs-content {
    .content-header {
      width: 327px;
      height: 48px;
      background: url('../../assets/hzvtc/detail/title.png') no-repeat
        center/cover;
      text-align: center;
      margin: 0 auto;
      font-size: 20px;
      font-weight: bold;
      color: #efe7df;
      line-height: 48px;
    }
    .details-content {
      margin-bottom: 63px;
      position: relative;
      &::before {
        content: '';
        display: block;
        width: 100%;
        height: 85px;
        background: url('../../assets/hzvtc/detail/header-bg.png') no-repeat
          center/cover;
      }

      .details-color {
        width: 100%;
        background: #efe7df;
        padding: 20px 48px 32px;
        min-height: 280px;
        .content-header {
          margin-bottom: 22px;
        }
        .content-box {
          ::v-deep * {
            font-size: 16px !important;
            line-height: 25px !important;
            background: transparent !important;
            font-family: Microsoft YaHei !important;
          }
          ::v-deep p {
            margin-bottom: 10px;
            text-indent: 2em !important;
          }
          ::v-deep img,
          ::v-deep video,
          ::v-deep audio {
            max-width: 80%;
            display: block;
            margin: 0 auto;
          }
        }
      }
    }
    .details-list {
      .content-header {
        margin-bottom: 33px;
        position: relative;
        z-index: 2;
      }
      .content-box {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        position: relative;
        width: 1120px;
        margin: 0 auto;
        &::before {
          content: '';
          position: absolute;
          display: inline-block;
          width: 100%;
          height: 100%;
          border: 1px dashed #794b1e;
          box-sizing: content-box;
          padding: 56px 40px 8px;
          left: 50%;
          transform: translateX(-50%);
          top: -55px;
          z-index: 1;
        }
        &::after {
          content: '';
          display: inline-block;
          width: 1920px;
          height: 100%;
          position: absolute;
          top: -108px;
          left: 50%;
          transform: translateX(-50%);
          background: #fbfaf8;
          box-sizing: content-box;
          padding: 108px 0 60px;
        }
        .course-item {
          margin-bottom: 28px;
          width: 346px;
          height: 195px;
          position: relative;
          cursor: pointer;
          z-index: 2;
          p {
            display: block;
            width: 100%;
            height: 42px;
            line-height: 42px;
            background: rgba(0, 0, 0, 0.5);
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 16px;
            font-weight: bold;
            color: #eed8a5;
            padding: 0 14px;
            position: absolute;
            bottom: 0;
            left: 0;
          }
        }
        .sub-visibility {
          display: block;
          visibility: hidden;
          flex: 346px 0 0;
        }
      }
    }
    .details-appraise {
      display: flex;
      margin-top: 92px;
      .appraise-header {
        font-size: 20px;
        font-weight: bold;
        color: #333333;
        line-height: 1;
        padding-bottom: 21px;
        position: relative;
        &::before {
          content: '';
          display: inline-block;
          width: 80px;
          height: 6px;
          background: #6a3714;
          position: absolute;
          left: 0;
          bottom: -4px;
        }
      }
      .appraise-content {
        flex: 1;
        .appraise-header {
          border-bottom: 1px solid #efe7df;
        }
        .content-box {
          width: 100%;
          padding: 42px 0 54px;
          .appraise-item {
            display: flex;
            &:not(:last-child) {
              margin-bottom: 50px;
            }
            .avatar {
              width: 46px;
              height: 46px;
              margin-right: 20px;
              flex-shrink: 0;
              border-radius: 50%;
              background: url('../../assets/user.png') no-repeat center/cover;
            }
            .appraise-info {
              flex: 1;
              .basic-info {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding-bottom: 12px;
                .user-info {
                  display: flex;
                  align-items: center;
                  .user-name {
                    font-size: 14px;
                    color: #333333;
                    margin-right: 12px;
                    flex-shrink: 0;
                  }
                  .star-content {
                    display: flex;
                    align-items: center;
                    .star-item {
                      width: 18px;
                      height: 18px;
                      background: url('../../assets/hzvtc/detail/score-active.png')
                        no-repeat center/cover;
                      &.empty {
                        background: url('../../assets/hzvtc/detail/score-normal.png')
                          no-repeat center/cover;
                      }
                    }
                  }
                }
                .publish-time {
                  font-size: 12px;
                  color: #9d9d9d;
                }
              }
              .appraise-text {
                font-size: 14px;
                color: #666666;
                line-height: 24px;
              }
            }
          }
        }
      }
      .suggest-content {
        width: 300px;
        margin-left: 60px;
        .content-box {
          width: 100%;
          background: #f9fbfc;
          padding: 33px 10px 15px;
          .course-item {
            width: 100%;
            height: 157px;
            cursor: pointer;
            &:not(:last-child) {
              margin-bottom: 8px;
            }
          }
        }
      }
    }
    .appraise-container {
      width: 838px;
      height: 227px;
      background: #ffffff;
      border: 1px solid #eff0f6;
      display: flex;
      flex-direction: column;
      .appraise-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 15px 0 25px;
        width: 100%;
        height: 58px;
        background: #f5f4f2;
        .appraise-star {
          display: flex;
          align-items: center;
          .header-text {
            font-size: 17px;
            font-weight: bold;
            color: #333333;
            margin-right: 20px;
          }
          .header-score {
            display: flex;
            align-items: center;
            .score-item {
              width: 26px;
              height: 26px;
              background: url('../../assets/hzvtc/detail/score-active.png')
                no-repeat center/cover;
              cursor: pointer;
              transition: all 0.3s;
              &.unActive {
                background: url('../../assets/hzvtc/detail/score-normal.png')
                  no-repeat center/cover;
              }
            }
          }
        }
        .appraise-submit {
          cursor: pointer;
          width: 71px;
          height: 33px;
          background: #b61e2a;
          border: 1px solid #f6e9c7;
          border-radius: 1px 4px 1px 1px;
          text-align: center;
          line-height: 32px;
          font-size: 16px;
          font-weight: bold;
          color: #ffffff;
        }
      }
      .appraise-area {
        flex: 1;
        textarea {
          width: 100%;
          height: 100%;
          border: none;
          padding: 15px 25px;
          resize: none;
          font-size: 16px;
          color: #666666;
          &::placeholder {
            font-size: 16px;
            color: #b7b6b6;
          }
        }
      }
    }
  }
}
::v-deep .footer-container {
  margin: -30px 0 0;
}
.empty-content {
  .empty-text {
    color: #666;
    text-align: center;
    padding: 50px 0;
  }
}
#content,
#appraise {
  position: relative;
  top: -50px;
}

#main {
  position: relative;
  .fixed-nav {
    width: 148px;
    height: 307px;
    background: url('../../assets/hzvtc/detail/fixed-nav.png') no-repeat
      center/cover;
    padding: 50px 0 0;
    position: absolute;
    left: 170px;
    top: 85px;
    z-index: 101;
    &.fixed {
      position: fixed;
      left: 170px;
      top: 110px;
    }
    .fixed-nav-item {
      width: 132px;
      height: 36px;
      text-align: center;
      line-height: 36px;
      margin: 0 auto;
      font-size: 16px;
      font-weight: bold;
      color: #545658;
      display: block;
      cursor: pointer;
      &:not(:last-child) {
        margin-bottom: 15px;
      }
      &.active {
        background: url('../../assets/hzvtc/detail/fixed-nav-item.png')
          no-repeat center/cover;
        font-size: 16px;
        font-weight: bold;
        color: #efe7df;
      }
    }
  }
}
</style>